const Main = () => {
	return (
		<div>
			<h1>React App - MUI template</h1>
		</div>
	);
};

export default Main;
